module.exports = __webpack_public_path__ + "static/media/icon-lock.12374343.svg";